<template>
  <v-card flat id="corpusStatsCard">
    <v-toolbar flat color="grey lighten-3">
      <v-toolbar-title>{{ $t('dataset.corpus.corpus') }}</v-toolbar-title>
    </v-toolbar>
    <div id="project_corpus_info">
      <v-container v-if="stats.corpusReady" id="corpusStats">
        <v-layout wrap>
          <v-flex xs12 md3>
            <v-card flat>
              <v-card-text id="corpusDocs" class="text--primary">
                <strong>{{ stats.corpus.documentCount }}</strong>
                {{ $tc('dataset.common.documents', stats.corpus.documentCount) }}
                ({{ stats.corpus.corpusSize | numeral('0b') }})
              </v-card-text>
            </v-card>
            <v-card flat>
              <v-card-text id="corpusSegs" class="text--primary" v-if="stats.corpus.segmentCount">
                <strong>{{ stats.corpus.segmentCount }}</strong>
                {{ $tc('dataset.common.segments', stats.corpus.segmentCount) }}
              </v-card-text>
            </v-card>
            <v-card flat>
              <v-card-text id="corpusSegPerDoc" class="text--primary" v-if="stats.corpus.segmentCount">
                <strong>{{ stats.corpus.segmentCount / stats.corpus.documentCount | numeral('0.[0]') }}</strong>
                {{ $tc('dataset.common.segments', stats.corpus.segmentCount) }}/{{ $tc('dataset.common.documents', 1) }}
                ({{ stats.corpus.corpusSize / stats.corpus.segmentCount | numeral('0b') }})
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex v-if="hasValidCorpus" id="corpusStatsDocs" md6>
            <v-select
                v-show="metafacets && metafacets.length > 1"
                id="corpusMetadataSelectorSb"
                outlined
                v-model="metadataSelector"
                :items="metafacets"
                :label="$t('dataset.common.metadataSelection')"
                item-text="text"
                item-value="value"
                @change="getCorpusStats(metadataSelector)"
            ></v-select>
            <apexchart
                ref="corpusDonut"
                type="donut"
                width="100%"
                height="320"
                :options="corpusDonut.chartOptions"
                :series="corpusDonut.series"
                class="hidden-xs-only"
            ></apexchart>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container v-else>
        <v-progress-circular :value="0" id="emptyCorpusData"/>
      </v-container>
    </div>
  </v-card>
</template>

<script>
import {mapState, mapActions} from "vuex";

export default {
  data() {
    return {
      metadataSelector: ""
    };
  },
  //props: ["statistics"],
  mounted: function () {
    // WTF??? commented-out
    // this.fetchProjects().then(this.maybebStartTour);
    this.metadataSelector = this.project.metafacets ? this.project.metafacets[0] : ""
    this.getCorpusStats(this.metadataSelector);
  },
  computed: {
    ...mapState(["project"]),
    ...mapState("dataset", ["stats"]),
    metafacets() {
      return this.project.metafacets
    },
    hasValidCorpus() {
      return (
          this.stats &&
          this.stats.corpus &&
          this.stats.corpus.documentFacets &&
          this.stats.corpus.documentFacets.facets &&
          this.stats.corpus.documentFacets.metadata
      );
    },
    corpusDonut() {
      var series = [];
      var labels = [];
      if (this.stats.corpus.documentFacets.facets) {
        let otherCnt = 0;
        let facetsCnt = 0;
        this.stats.corpus.documentFacets.facets.forEach(element => {
          if (facetsCnt < 12 && element.documentCount > 1) {
            labels.push(
                !element._id
                    ? this.$t("dataset.common.no_value")
                    : element._id
            );
            series.push(element.documentCount);
            facetsCnt++;
          } else {
            otherCnt += element.documentCount;
          }
        });
        if (otherCnt > 0) {
          labels.push(this.$t("dataset.common.other"));
          series.push(otherCnt);
        }
      }
      return {
        series,
        chartOptions: {
          yaxis: {
            show: true,
            forceNiceScale: true,
            decimalsInFloat: 0
          },
          chart: {
            height: 280,
            events: {
              dataPointSelection: function (
                  event,
                  chartContext,
                  {w, dataPointIndex}
              ) {
                console.log(`clicked on ${w.config.labels[dataPointIndex]}`);
              }
            }
          },
          dataLabels: {
            enabled: true,
            // eslint-disable-next-line
            formatter: function (value, {seriesIndex, w}) {
              // return `${w.config.labels[seriesIndex]} (${Math.floor(value)}%)`;
              return `${Math.floor(value)}%`;
            }
          },
          title: {
            text: this.$t("dataset.corpus.corpusDistribution", {
              metadata: this.metadataSelector
            }),
            align: "center",
            margin: 10,
            style: {
              fontSize: "15px"
            }
          },
          labels,
          plotOptions: {
            pie: {
              donut: {
                size: "35%"
              }
            }
          },
          legend: {
            horizontalAlign: "center",
            offsetY: 50
          }
        }
      };
    },
  },
  methods: {
    ...mapActions("home", ["fetchProjects"]),
    ...mapActions("dataset", ["getCorpusStats"]),
  }
};
</script>

            

        
